import {useState} from 'react';
import clsx from 'clsx';
import {CopyIcon} from '../icons';
import Tooltip from '../tooltip/tooltip';
import * as copyStyles from './copy.module.css';

interface ICopyTextIcon {
    textToCopy: string,
    tooltip: string,
    isInputPrefix?: boolean,
}

const CopyTextIcon = ({textToCopy, tooltip, isInputPrefix = false}: ICopyTextIcon) => {
    const [copied, setCopied] = useState(false);
    const onCopyClick = () => {
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 1000);
            });
    };

    return (
        <span
            className={clsx(
                isInputPrefix && copyStyles.inputPrefix,
            )}
        >
            <Tooltip text={copied ? 'Copied' : tooltip}>
                <button
                    className={copyStyles.icon}
                    onClick={onCopyClick}
                >
                    <CopyIcon/>
                </button>
            </Tooltip>
        </span>
    );
};

export default CopyTextIcon;
